
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/shipping-policy",
      function () {
        return require("private-next-pages/policies/shipping-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/shipping-policy"])
      });
    }
  